import { render } from "./HakoniA.vue?vue&type=template&id=dcfc4e0c"
import script from "./HakoniA.vue?vue&type=script&lang=js"
export * from "./HakoniA.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__